module.exports = __webpack_public_path__ + "static/img/3.c40b90b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myprize/3.png
// module id = vfQF
// module chunks = 1